import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@avangard/ui/utils';

import { PageFilters } from '@modules/shared/organisms';
import { useCurrentUser } from '@modules/user/hooks';
import { useSummaryLapsSchoolsTableFiltersQuery } from '@modules/summary-results/hooks';
import { UserGrantActionToken, UserGrantCategoryToken } from '@modules/types/graphql';
import { ToolbarFilters } from './toolbar-filters';

const Root = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    ${breakpoints.down('sm')} {
        flex-wrap: wrap;
    }
`;

const initialFilters = {
    shortName: '',
};

const SummarySchoolsListFilters = (): React.ReactElement => {
    const { currentUser } = useCurrentUser();
    const { summaryResultSchoolGrants } = currentUser.can({
        [UserGrantCategoryToken.summaryResultSchool]: [UserGrantActionToken.search],
    });

    const { filters: queryFilters } = useSummaryLapsSchoolsTableFiltersQuery();

    return (
        <Root>
            <PageFilters queryFilters={queryFilters} initials={initialFilters}>
                {summaryResultSchoolGrants.canSearch ? <ToolbarFilters /> : null}
            </PageFilters>
        </Root>
    );
};

export { SummarySchoolsListFilters };
